__turbopack_context__.v({
  "simulation-card-wrapper": "StartSimulation-module-scss-module__y1GB5a__simulation-card-wrapper",
});
